var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcList = function SvgIcList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F3F45",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M3.75 5.75h16.5M3.75 11.75h16.5M3.75 17.75h16.5"
  })));
};
export default SvgIcList;